import { Grid, Modal as ModalModule, Utils } from 'common';
import PropTypes from 'prop-types';
import React from 'react';

const { GridPanel } = Grid;
const { Modal } = ModalModule;
const { withLayoutAndModalContexts } = Utils;

const usCurrencyFormatter = new Intl.NumberFormat('en-US', {
	style: 'currency',
	currency: 'USD',
});

class RefundDetailsModal extends React.Component {
	constructor(props) {
		super(props);

		const { data = {} } = props;
		const { selectedPrints } = data;

		this.state = {
			columnDefs: [
				{
					field: 'refundId',
					headerName: 'Refund ID',
					width: 110,
				},
				{
					field: 'refundType',
					headerName: 'Refund Type',
					width: 130,
				},
				{
					field: 'refundStatus',
					headerName: 'Status',
					width: 130,
				},
				{
					field: 'refundRequestedAmount',
					headerName: 'Requested',
					width: 110,
					type: 'numericColumn',
					cellClass: 'align-right',
					cellRenderer({ value }) {
						return value ? usCurrencyFormatter.format(value) : '';
					},
				},
				{
					field: 'netRefundApprovedAmount',
					headerName: 'Approved',
					width: 120,
					type: 'numericColumn',
					cellClass: 'align-right',
					cellRenderer({ value }) {
						return usCurrencyFormatter.format(value);
					},
				},
				{
					field: 'refundApprovedAmount',
					headerName: 'Credited Amount',
					width: 170,
					type: 'numericColumn',
					cellClass: 'align-right',
					cellRenderer({ value }) {
						return usCurrencyFormatter.format(value || 0);
					},
				},
			],
			rowData: selectedPrints,
		};
	}

	render() {
		const { modalId } = this.props;
		const { columnDefs, rowData = [] } = this.state;

		const updatedRowData = rowData.map(data => {
			if (data.isRefundAssist) {
				data.refundType = 'Refund Assist';
			}

			// If netRefundApprovedAmount is null, set it to refundApprovedAmount.
			// This is to support Refund Assist
			if (data.netRefundApprovedAmount === null) {
				data.netRefundApprovedAmount = data.refundApprovedAmount;
			}

			return data;
		});

		const requestedTotalAmount = rowData?.reduce(
			(total, { refundRequestedAmount = 0 }) => total + refundRequestedAmount,
			0
		);
		const approvedTotalAmount = rowData.reduce(
			(total, { refundApprovedAmount }) => total + refundApprovedAmount,
			0
		);
		const netRefundApprovedTotalAmount = rowData.reduce(
			(total, { netRefundApprovedAmount }) => total + netRefundApprovedAmount,
			0
		);

		return (
			<Modal
				modalId={modalId}
				className="history-refund refund-details-modal"
				header="Refund Details"
				hideFooter
			>
				<GridPanel
					className="history-refund grid"
					columnDefs={columnDefs}
					domLayout="autoHeight"
					defaultColDef={{
						suppressSizeToFit: true,
						suppressMovable: true,
						sortable: false,
						suppressMenu: true,
					}}
					rowData={updatedRowData}
					showPagination={false}
				/>
				<div className="modal-footer">
					<div className="col col-label">Total</div>
					<div className="col col-number total-request">
						{usCurrencyFormatter.format(requestedTotalAmount)}
					</div>
					<div className="col col-number total-refunded">
						{usCurrencyFormatter.format(netRefundApprovedTotalAmount)}
					</div>
					<div className="col col-number total-approved">
						{usCurrencyFormatter.format(approvedTotalAmount)}
					</div>
				</div>
			</Modal>
		);
	}
}

RefundDetailsModal.propTypes = {
	data: PropTypes.shape({
		selectedPrints: PropTypes.array,
	}),
};

export default withLayoutAndModalContexts(RefundDetailsModal);
